import { QuoteSheetDetailSlidein } from '@/components/procurement/quote-sheet-detail/quote-sheet-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const { quoteSheetId } = useParams({
    from: '/authenticated/price-sheet-inbox/$quoteSheetId',
  });
  const navigate = useNavigate();

  return (
    <QuoteSheetDetailSlidein
      quoteSheetId={quoteSheetId}
      isOpen={true}
      onOpenChange={() => {
        navigate({
          to: '/price-sheet-inbox',
          viewTransition: true,
        });
      }}
    />
  );
}
